import { FC } from 'react'

import { Pagination } from '@syconium/little-miss-figgy/dist/components/Pagination'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { ProductReviewsContainer } from '../../../../../containers/ProductReviewsContainer'
import { useProductReviewFilters } from '../../../../../lib/hooks/useProductReviewFilters'

export const ProductReviewsPagination: FC = () => {
  const { results } = ProductReviewsContainer.useContainer()
  const { filters, updateFilters } = useProductReviewFilters()
  const {
    magnolia: { reviewsPage },
  } = useTranslation()

  const onPageChange = (newPage: number) => {
    updateFilters({ ...filters, page: newPage.toString() })
  }

  if (!results?.pagination || (results.totalReviews ?? 0) < 1) return null

  return (
    <Pagination
      currentPage={results.pagination.pageNum ?? 1}
      onChange={onPageChange}
      pagesCount={results.pagination.numPages ?? 1}
      previousPageLabel={reviewsPage.pagination.previous}
      nextPageLabel={reviewsPage.pagination.next}
    />
  )
}
